module.exports = __webpack_public_path__ + "img/JF-JG.5696cc5d.png";